export const mainLayoutStyles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: 'background.default',
  },

  mainContent: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    bgcolor: 'background.default',
  },

  contentWrapper: {
    flexGrow: 1,
    width: { lg: 'calc(100% - 280px)' },
    overflow: 'auto',
  },
};
